import React from 'react';

const Footer = () => (
   <>
      <div className="text-white text-center bg-footer py-3" id="contact">
         <small className="mt-2">
            Desenvolvido pelo DTI - Departamento de Tecnologia da Informação <br />
				Secretaria de Ciência, Tecnologia e Inovação
         </small>
      </div>
   </>
);
export default Footer;